import {Node} from 'tiptap';
import ImageExtensionView from "@/components/tiptap/extensions/Nodes/ImageExtensionView";

export default class ImageExtension extends Node {
    get name() {
        return 'imageNode';
    }

    get schema () {
        return {
            // here you have to specify all values that can be stored in this node
            attrs: {
                align: {
                    default: null
                },
                alt: {
                    default: null
                },
                caption: {
                    default: null
                },
                credit: {
                    default: null
                },
                src: {
                    default: null
                },
                width: {
                    default: null
                },
                style: {
                    default: null
                },
            },
            group: 'block',
            content: 'inline*',
            draggable: true,
            // parseDOM and toDOM is still required to make copy and paste work
            parseDOM: [{
                tag: 'img',
                getAttrs: dom => ({
                    align: dom.getAttribute('align'),
                    alt: dom.getAttribute('alt'),
                    caption: dom.getAttribute('caption'),
                    credit: dom.getAttribute('credit'),
                    src: dom.getAttribute('src'),
                    width: dom.getAttribute('width'),
                    style: dom.getAttribute('style'),
                }),
            }],
            toDOM: node => ['img', {
                align: node.attrs.align,
                alt: node.attrs.alt,
                caption: node.attrs.caption,
                credit: node.attrs.credit,
                src: node.attrs.src,
                width: node.attrs.width,
                style: node.attrs.style,
            }]
        }
    }
    commands ({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(type.create({
                'src': (attrs) ? attrs.src : null,
                'alt': (attrs) ? attrs.alt : null,
                'caption': (attrs) ? attrs.caption : null,
                'credit': (attrs) ? attrs.credit : null,
                'width': (attrs) ? attrs.width : null,
                'align': (attrs) ? attrs.align : null,
                'style': (attrs) ? attrs.style : null,
            })))
        }
    }
    get view () {
        return ImageExtensionView
    }
}

